import React from 'react';
import { motion } from 'framer-motion';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 30
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.7,
  delay,
  ease: [0.21, 0.47, 0.32, 0.98]
}} className={className} data-id="element-166">
    {children}
  </motion.div>;
export const Section = ({
  children,
  className = '',
  id
}: {
  children: ReactNode;
  className?: string;
  id?: string;
}) => <section id={id} className={`py-20 px-6 ${className}`} data-id="element-167">
    <div className="max-w-[800px] mx-auto" data-id="element-168">{children}</div>
  </section>;
export const SectionLabel = ({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) => <p className={`text-[0.78rem] font-bold tracking-[2px] uppercase text-brand-pink mb-[14px] ${className}`} data-id="element-169">
    {children}
  </p>;
export const ButtonPrimary = ({
  text,
  href,
  className = ''
}: {
  text: string;
  href: string;
  className?: string;
}) => <a href={href} className={`inline-block bg-brand-white text-brand-purple px-12 py-[18px] rounded-full font-bold text-[1.1rem] no-underline transition-all duration-200 shadow-[0_8px_30px_rgba(0,0,0,0.2)] hover:-translate-y-[2px] hover:shadow-[0_12px_40px_rgba(0,0,0,0.3)] ${className}`} data-id="element-170">
    {text}
  </a>;
export const ButtonSecondary = ({
  text,
  href,
  className = ''
}: {
  text: string;
  href: string;
  className?: string;
}) => <a href={href} className={`inline-block bg-brand-purple text-brand-white px-12 py-[18px] rounded-full font-bold text-[1.1rem] no-underline transition-all duration-200 shadow-[0_8px_30px_rgba(0,0,0,0.2)] hover:-translate-y-[2px] hover:shadow-[0_12px_40px_rgba(0,0,0,0.3)] ${className}`} data-id="element-171">
    {text}
  </a>;